import { Card } from '@ui/themed';
import type { PropsWithChildren } from 'react';

export function ListCard(props: PropsWithChildren<{ title: string }>) {
  return (
    <Card>
      <Card.Header headingLevel="h2">{props.title}</Card.Header>
      <Card.Body>{props.children}</Card.Body>
    </Card>
  );
}
